export const baseUrl = 'https://www.instagram.com/'
export const commentFilterUrl = 'https://www.instagram.com/accounts/comments/'
export const emailNotificationSettingsUrl =
  'https://www.instagram.com/emails/settings/'
export const taggingAndMentions =
  'https://www.instagram.com/accounts/settings/v2/tags_and_mentions/'
export const professionalAccountSettingsUrl =
  'https://www.instagram.com/accounts/professional_account_settings/'
export const pushNotificationSettingsUrl =
  'https://www.instagram.com/push/web/settings/'
export const settingsHomeUrl = 'https://www.instagram.com/accounts/edit/'
export const storySettingsUrl =
  'https://www.instagram.com/accounts/story_replies/'
export const accountPrivacyUrl =
  'https://www.instagram.com/accounts/settings/v2/account_privacy/'
export const languageSettingsUrl =
  'https://www.instagram.com/language/preferences/'
export const accountCenterTwoFactorAuthUrl =
  'https://accountscenter.instagram.com/password_and_security/two_factor/'
export const yourActivityPostsUrl =
  'https://www.instagram.com/your_activity/photos_and_videos/posts/'
export const yourActivityReelsUrl =
  'https://www.instagram.com/your_activity/photos_and_videos/reels'
export const hiddenWordsUrl =
  'https://www.instagram.com/accounts/settings/hidden_words/'
export const activityStatusUrl =
  'https://www.instagram.com/accounts/activity_status/'
export const manuallyApproveTags =
  'https://www.instagram.com/accounts/manually_approve_tags'
